import { Column, Row } from 'hatch-components';
import styled from 'styled-components';

export const StyledCard = styled(Column)(
  ({ theme: { colors, border, spacing, shadows } }) => ({
    background: colors.white,
    borderRadius: border.radius.sm,
    boxShadow: shadows.primary,
    flexShrink: 0,
    overflow: 'hidden',
    paddingBottom: spacing.lg,
    position: 'relative',
    width: '100%',
  }),
);

export const StyledCardHeader = styled(Row)(
  ({
    theme: {
      border,
      spacing,
      responsive: { mobile },
    },
  }) => ({
    alignItems: 'center',
    borderRadius: `${border.radius.sm} ${border.radius.sm} 0 0`,
    height: 95,
    justifyContent: 'space-between',
    [mobile]: {
      padding: `0 ${spacing.md}`,
    },
    padding: `0 ${spacing.lg}`,
    width: '100%',
  }),
);

export const StyledTitle = styled.h1(({ theme: { font, colors } }) => ({
  color: colors.secondary,
  fontSize: font.size.xl,
  fontWeight: font.weight.extraBold,
  lineHeight: font.lineHeight.xl,
}));
